import { useMemo } from 'react'
import { useWeb3React } from '@web3-react/core'
import { toBigNumber, formatFormAmount } from '~/utils/numbers'
import { StyledBalanceContainer } from './styled'
import { useTranslation } from 'react-i18next'
import Tooltip from '~/components/Tooltip'
import { useSpotSwapPair } from '~/state/dex/hooks'
import { AddressZero } from '@ethersproject/constants'
import { useNativeTokenBalance, useTokenBalance } from '~/state/wallet/hooks'

interface LabelFromProps {
  gasFee: string | undefined
  onMax: () => void
}

const LabelFrom: React.FC<LabelFromProps> = ({ gasFee, onMax }) => {
  const { account } = useWeb3React()
  const isWalletConnected = !!account
  const { t } = useTranslation()
  const [inputToken] = useSpotSwapPair()
  const isSellETH = inputToken?.address === AddressZero

  const ethBalance = useNativeTokenBalance()
  const tokenBalance = useTokenBalance(account, {
    address: inputToken?.address,
    decimals: inputToken?.decimals,
    name: '',
    symbol: inputToken?.symbol,
  })

  const ethBalanceStr = ethBalance?.toDecimalsFixed(ethBalance.decimals)
  const tokenBalanceStr = tokenBalance?.toDecimalsFixed(inputToken?.decimals)

  const balance = isSellETH ? ethBalanceStr : tokenBalanceStr

  const maxTradableETHBalance = useMemo(() => {
    let result = ethBalanceStr
    if (isSellETH) {
      const calcBalance = toBigNumber(ethBalanceStr).minus(gasFee ?? 0)
      if (calcBalance.lt(0)) {
        result = '0'
      } else result = calcBalance.toFixed()
    }
    return result
  }, [ethBalanceStr, gasFee])

  return (
    <StyledBalanceContainer>
      {isWalletConnected && (
        <div>
          <span className="amount">
            {t('balance')}: {formatFormAmount(balance, 4)} {inputToken?.symbol}
          </span>
          {Number(balance) !== 0 ? (
            isSellETH ? (
              <Tooltip
                placement="right"
                title={t('spotswap_max_btn_tooltip')}
                tooltipTitle={t('spotswap_max_btn_tooltip_title')}
                tooltipTitleValue={`${formatFormAmount(
                  maxTradableETHBalance,
                )} ETH`}
                trigger="hover"
              >
                <span onClick={onMax} className="max">
                  MAX
                </span>
              </Tooltip>
            ) : (
              <span onClick={onMax} className="max">
                MAX
              </span>
            )
          ) : null}
        </div>
      )}
    </StyledBalanceContainer>
  )
}

export default LabelFrom
